import { render, staticRenderFns } from "./ExamineTabs.vue?vue&type=template&id=5f239cea&scoped=true"
import script from "./ExamineTabs.vue?vue&type=script&lang=ts"
export * from "./ExamineTabs.vue?vue&type=script&lang=ts"
import style0 from "./ExamineTabs.vue?vue&type=style&index=0&id=5f239cea&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f239cea",
  null
  
)

export default component.exports